<template>
  <div>
    <v-data-table
      disable-sort
      :loading="loadingTable"
      :headers="headers"
      :items="checkouts"
      class="elevation-1"
      :page-count="numberOfPagesPaginate"
      :page="currentPagePaginate"
      :server-items-length="totalStagesPaginate"
      :options.sync="options"
      :footer-props="{
        itemsPerPageText: 'Itens por pagina',
        itemsPerPageOptions: [5, 10, 15, 50],
        showFirstLastPage: true,
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Checkouts</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-badge
            :content="bagFilter"
            :value="bagFilter"
            bordered
            color="error"
            overlap
          >
            <v-btn
              large
              outlined
              rounded
              color="primary"
              @click="dialogFilter = true"
            >
              <v-icon>
                {{ icons.mdiFilter
                }}
              </v-icon>filtros
            </v-btn>
          </v-badge>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                icon
                small
                outlined
                large
                class="ml-2"
                color="primary"
                v-on="on"
                @click="sendExportPdf()"
              >
                <v-icon>{{ icons.mdiPrinter }}</v-icon>
              </v-btn>
            </template>
            <span>Imprimir</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            :append-icon="icons.mdiMagnify"
            class="mt-6"
            dense
            rounded
            outlined
            label="Pesquisar"
            placeholder="Número da reserva"
            clearable
            style="max-width: 450px;"
            @click:append="confirmSearch()"
            @keyup.enter="confirmSearch()"
            @click:clear="confirmSearch()"
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>

      <template v-slot:item.id="{ item }">
        <div style="font-size: 18px">
          {{ item.id }}
        </div>
      </template>
      <template v-slot:item.user="{ item }">
        <div style="font-size: 18px">
          {{ item.user.name }}
        </div>
      </template>
      <template v-slot:item.date_sale="{ item }">
        <div style="font-size: 18px">
          {{ formatDateTime(item.date_sale) }}
        </div>
      </template>

      <template v-slot:item.total="{ item }">
        <div style="font-size: 18px">
          {{ formatMoney(item.total) }}
        </div>
      </template>

      <template v-slot:item.financial_label="{ item }">
        <v-tooltip
          v-if="isGroupCheckout(item)"
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              v-bind="attrs"
              x-small
              :color="item.group_account && item.group_account.status === 'sent' ? 'info' : 'warning'"
              :text-color="item.group_account && item.group_account.status === 'sent' ? 'white' : 'black'"
              v-on="on"
            >
              {{ item.financial_label }}
            </v-chip>
          </template>
          <span>Fólio: {{ item.group_folio_key }}</span>
        </v-tooltip>
        <v-chip
          v-else
          x-small
          outlined
        >
          Individual
        </v-chip>
      </template>

      <template v-slot:item.room="{ item }">
        <div style="font-size: 18px">
          {{ item.accommodation.room ? item.accommodation.room.description : 'N/A' }}
        </div>
      </template>

      <template v-slot:item.guests="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span
              style="font-size: 18px"
              v-bind="attrs"
              v-on="on"
            >{{ item.accommodation.guest[0].name }}</span>
          </template>
          <span style="font-size: 18px">{{ joinGuest(item) }}</span>
        </v-tooltip>
      </template>

      <template v-slot:item.tomador="{ item }">
        <v-tooltip
          v-if="getTomadores(item).length > 1"
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <span
              style="font-size: 18px"
              v-bind="attrs"
              v-on="on"
            >
              {{ getTomadores(item)[0] }}
            </span>
          </template>
          <span style="font-size: 18px">
            {{ joinTomadores(item) }}
          </span>
        </v-tooltip>
        <span
          v-else
          style="font-size: 18px"
        >
          {{ getTomador(item) }}
        </span>
      </template>

      <template v-slot:item.actions="{ item }">
        <div style=" white-space: nowrap;">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                :loading="item.loading_print"
                :disabled="item.loading_print"
                color="secondary"
                v-bind="attrs"
                @click="showNote(item)"
                v-on="on"
              >
                <v-icon>
                  {{ icons.mdiNoteOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>Observações</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                :loading="item.loading_print"
                :disabled="item.loading_print"
                color="secondary"
                v-bind="attrs"
                @click="exportPdf(item)"
                v-on="on"
              >
                <v-icon>
                  {{ icons.mdiPrinter }}
                </v-icon>
              </v-btn>
            </template>
            <span>Imprimir</span>
          </v-tooltip>
          <!-- Notas fiscais quando enviado -->
          <v-tooltip
            v-if="item.is_sent == 1 && !isGroupCheckout(item)"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                :loading="item.loading_notes"
                :disabled="item.loading_notes"
                color="secondary"
                v-bind="attrs"
                @click="fetchNotes(item)"
                v-on="on"
              >
                <v-icon>
                  {{ icons.mdiFilePdfBox }}
                </v-icon>
              </v-btn>
            </template>
            <span>Notas fiscais</span>
          </v-tooltip>
          <v-tooltip
            v-if="!isGroupCheckout(item)"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                :loading="item.loading_print"
                :disabled="item.loading_print"
                color="secondary"
                v-bind="attrs"
                @click="exportPdfRpd(item)"
                v-on="on"
              >
                <v-icon>
                  {{ icons.mdiFileDocumentOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>RPS</span>
          </v-tooltip>

          <v-tooltip
            v-if="item.is_sent == 1 && !isGroupCheckout(item)"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                :loading="item.loading_print"
                :disabled="item.loading_print"
                color="secondary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>
                  {{ icons.mdiSendCheck }}
                </v-icon>
              </v-btn>
            </template>
            <span>Enviado</span>
          </v-tooltip>
          <v-tooltip
            v-if="item.is_sent == 0 && !isGroupCheckout(item)"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                :loading="item.loading_send"
                :disabled="item.loading_send"
                color="warning"
                v-bind="attrs"
                v-on="on"
                @click="sendSingleCheckoutToGestao(item)"
              >
                <v-icon>
                  {{ icons.mdiSendClock }}
                </v-icon>
              </v-btn>
            </template>
            <span>Enviar para gestão</span>
          </v-tooltip>
          <v-tooltip
            v-if="item.is_sent == 0 && !isGroupCheckout(item)"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="secondary"
                v-bind="attrs"
                @click="cancelCheckout(item)"
                v-on="on"
              >
                <v-icon>
                  {{ icons.mdiBackupRestore }}
                </v-icon>
              </v-btn>
            </template>
            <span>Reabrir Checkout</span>
          </v-tooltip>
        </div>
        <!-- <v-icon color="primary" class="mr-2" @click="editItem(item)">
                {{ icons.mdiPencilOutline }}
            </v-icon>
            <v-icon color="error" @click="deleteItem(item)">
                {{ icons.mdiDeleteOutline }}
            </v-icon>  -->
      </template>
      <template v-slot:no-data>
        <NoDataTable></NoDataTable>
      </template>
      <template v-slot:loading>
        Carregando...
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialogNote"
      width="600"
    >
      <v-card>
        <BarTitleDialog
          title="Observações"
          @close="dialogNote = false"
        />
        <v-card-text>
          <v-data-table
            hide-default-footer
            :headers="headers_observation"
            :items="accommodation_observations"
            class="elevation-1"
            dense
            hide-default-header
          >
            <template v-slot:no-data>
              <NoDataTable>Nenhuma observação disponível</NoDataTable>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row>
            <v-col class="text-right">
              <v-btn
                x-large
                color="secondary"
                @click="dialogNote = false"
              >
                fechar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG FILTRO -->
    <v-dialog
      v-model="dialogFilter"
      width="700"
    >
      <v-card>
        <BarTitleDialog
          title="FILTROS"
          @close="dialogFilter = false"
        />
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="filter.checkout_date"
                outlined
                type="date"
                label="Data Checkout"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row>
            <v-col class="text-left">
              <v-btn
                text
                color="error"
                x-large
                @click="clearFilter()"
              >
                limpar filtros
              </v-btn>
            </v-col>

            <v-col class="text-right">
              <v-btn
                text
                color="secondary"
                x-large
                @click="dialogFilter = false"
              >
                FECHAR
              </v-btn>
              <v-btn
                color="primary"
                class="ml-2"
                x-large
                @click="confirmFilter()"
              >
                aplicar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <MsgDelete
      v-model="dialogDelete"
      @delete-yes="deleteItemConfirm()"
    />

    <!-- DIALOG AUTHORIZATION -->
    <v-dialog
      v-model="dialogAuthorization"
      width="600"
    >
      <v-card>
        <BarTitleDialog
          title="Autorizar"
          @close="cancelAuthorization"
        />

        <v-card-text>
          <v-row class="mt-3">
            <v-col>
              <v-text-field
                v-model="admLogin.email"
                outlined
                label="Email"
                placeholder="Digite seu email"
                hide-details="auto"
                class="mb-6 mt-2"
                :error-messages="message_error_email"
                @keyup="validEmail"
              />

              <v-text-field
                v-model="admLogin.password"
                outlined
                label="Senha"
                type="password"
                placeholder="Digite sua senha"
                hide-details="auto"
                :error-messages="message_error_password"
                @keyup="validPassword"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text>
          <v-row>
            <v-col class="text-right">
              <v-btn
                text
                class="mr-2"
                x-large
                :disabled="authorizationProcessing"
                @click="cancelAuthorization()"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                x-large
                :loading="authorizationProcessing"
                :disabled="authorizationProcessing"
                @click="requestAuthorization()"
              >
                Autorizar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  mdiPrinter, mdiFilter, mdiNoteOutline, mdiSendClock, mdiSendCheck, mdiUpdate, mdiBackupRestore, mdiFileDocumentOutline, mdiFilePdfBox, mdiMagnify,
} from '@mdi/js'
import { mapActions } from 'vuex'
import MsgDelete from '@/components/MsgDelete.vue'
import NoDataTable from '@/components/NoDataTable.vue'
import BarTitleDialog from '@/components/BarTitleDialog.vue'

export default {
  components: {
    MsgDelete,
    NoDataTable,
    BarTitleDialog,
  },
  data: () => ({
    search: '',

    // FILTER
    filter: {},
    dialogFilter: false,
    note: '',
    dialogNote: false,
    loadingTable: false,
    totalStagesPaginate: 0,
    numberOfPagesPaginate: 0,
    currentPagePaginate: 0,
    dialogDelete: false,
    dialog: false,
    loading: false,

    // AUTHORIZATION
    dialogAuthorization: false,
    pendingAuthorization: null,
    authorizationProcessing: false,
    admLogin: {
      email: '',
      password: '',
    },
    message_error_email: '',
    message_error_password: '',
    headers: [
      {
        text: 'RESERVA',
        align: 'start',
        value: 'accommodation.reserve_id',
      },
      {
        text: 'DATA CHECKOUT',
        align: 'start',
        value: 'date_sale',
      },
      {
        text: 'QUARTO',
        align: 'start',
        value: 'room',
      },
      {
        text: 'VALOR',
        value: 'total',
      },
      {
        text: 'FINANCEIRO',
        value: 'financial_label',
      },
      {
        text: 'USUÁRIO',
        align: 'start',
        value: 'user',
      },
      {
        text: 'EMPRESA',
        value: 'accommodation.company.fantasy_name',
      },
      {
        text: 'HÓSPEDES',
        align: 'start',
        value: 'guests',
      },
      {
        text: 'TOMADOR',
        align: 'start',
        value: 'tomador',
      },
      {
        text: '',
        align: 'end',
        value: 'actions',
        sortable: false,
      },
    ],
    checkouts: [],
    editedIndex: -1,
    editedItem: {
      description: '',
    },
    defaultItem: {
      description: '',
    },
    options: {
      itemsPerPage: 50,
      page: 1,
    },
    icons: {
      mdiPrinter,
      mdiFilter,
      mdiNoteOutline,
      mdiSendClock,
      mdiSendCheck,
      mdiUpdate,
      mdiBackupRestore,
      mdiFileDocumentOutline,
      mdiFilePdfBox,
      mdiMagnify,
    },
    accommodation_observations: [],
    headers_observation: [
      {
        text: 'Observações',
        sortable: false,
        align: 'start',
        value: 'description',
      },
      {
        text: '',
        align: 'end',
        value: 'action',
      },
    ],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Novo Pix' : 'Editar Pix'
    },
    bagFilter() {
      let count = Object.keys(this.filter).length
      if (this.search && this.search.trim() !== '') {
        count++
      }

      return count
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },

    options: {
      handler() {
        this.initialize()
      },
    },
  },

  created() {
    // this.getCategory().then(response => {
    //   this.categoryItems = response.data
    // })

    this.initialize()
  },

  methods: {
    isGroupCheckout(checkout) {
      return checkout.financial_status === 'transferred_to_group_account'
    },
    ...mapActions('manager_checkouts', ['getAll', 'printCheckoutPdf', 'sendToGestao', 'sendSingleCheckout', 'revertCheckout', 'exportPdfReport', 'exportPdfRps', 'getNotesByReserve']),
    ...mapActions('busy', [
      'getAccommodationObservations',
    ]),
    ...mapActions('authorization', { runAuthorization: 'run' }),

    initialize() {
      this.loadingTable = true
      const { page, itemsPerPage } = this.options
      const payload = {
        itemsPerPage: itemsPerPage || 10,
        page,
        search: this.search,
        filter: this.filter,
      }

      this.getAll(payload)
        .then(response => {
          this.checkouts = response.data.data
          this.totalStagesPaginate = response.data.total
          this.numberOfPagesPaginate = response.data.last_page
          this.currentPagePaginate = response.data.current_page
        })
        .finally(() => {
          this.loadingTable = false
        })
    },
    async fetchNotes(item) {
      try {
        this.$set(item, 'loading_notes', true)
        const reserveId = item?.accommodation?.reserve_id
        if (!reserveId) {
          this.$toast.error('Reserva não encontrada para este checkout')

          return
        }
        const resp = await this.getNotesByReserve({ reserveId })
        const { status } = resp
        const data = resp.data || {}

        const summarizeErrors = (errors, level = 'info') => {
          if (!Array.isArray(errors) || errors.length === 0) return

          // Monta HTML com todos os erros
          const errorList = errors.map((e, index) => {
            const type = e?.type || 'unknown'
            const reason = e?.reason || ''
            const msg = e?.message || 'Erro desconhecido'
            const proposalId = e?.proposal_id ? ` (Proposta ${e.proposal_id})` : ''

            return `<li style="text-align: left; margin-bottom: 8px;">
              <strong>${type}${proposalId}</strong>
              ${reason ? `<br><small style="color: #666;">${reason}</small>` : ''}
              <br>${msg}
            </li>`
          }).join('')

          const icon = level === 'error' ? 'error' : 'info'
          const title = level === 'error'
            ? `${errors.length} Falha${errors.length > 1 ? 's' : ''} na Geração de Notas`
            : `${errors.length} Aviso${errors.length > 1 ? 's' : ''}`

          this.$swal({
            icon,
            title,
            html: `<ul style="list-style: none; padding: 0; max-height: 400px; overflow-y: auto;">${errorList}</ul>`,
            width: '600px',
            confirmButtonText: 'OK',
          })
        }

        if (status === 200 && data.status === 'generated' && Array.isArray(data.notes) && data.notes.length) {
          data.notes.forEach(n => {
            if (!n?.base64) return
            const filename = n?.filename || `nota-${reserveId}.pdf`
            const link = document.createElement('a')
            link.href = `data:${n?.mime || 'application/pdf'};base64,${n.base64}`
            link.download = filename
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          })
          this.$toast.success(data?.message || `${data.notes.length} nota(s) disponível(is).`)
          summarizeErrors(data?.errors, 'info')

          return
        }

        if (status === 202 || data.status === 'processing') {
          this.$toast.info(data?.message || 'Nota em processamento. Tente novamente em alguns minutos.')
          summarizeErrors(data?.errors, 'info')

          return
        }

        if (status === 404 || data.status === 'not_found') {
          this.$toast.error(data?.message || 'Reserva não localizada para emissão de nota')

          return
        }
        if (status === 422 || data.status === 'error') {
          this.$toast.error(data?.message || 'Falha ao obter nota (422)')

          return
        }

        this.$toast.error(data?.message || 'Falha ao obter notas')
      } catch (e) {
        const resp = e && e.response
        const status = resp && resp.status
        const data = resp && resp.data
        if (status === 404 || (data && data.status === 'not_found')) {
          this.$toast.error((data && data.message) || 'Reserva não localizada')
        } else if (status === 422 || (data && data.status === 'error')) {
          this.$toast.error((data && data.message) || 'Falha ao obter nota (422)')
          if (data && data.errors) {
            const errors = Array.isArray(data.errors) ? data.errors : []
            if (errors.length > 0) {
              const errorList = errors.map((e, index) => {
                const type = e?.type || 'unknown'
                const reason = e?.reason || ''
                const msg = e?.message || 'Erro desconhecido'
                const proposalId = e?.proposal_id ? ` (Proposta ${e.proposal_id})` : ''

                return `<li style="text-align: left; margin-bottom: 8px;">
                  <strong>${type}${proposalId}</strong>
                  ${reason ? `<br><small style="color: #666;">${reason}</small>` : ''}
                  <br>${msg}
                </li>`
              }).join('')

              this.$swal({
                icon: 'error',
                title: `${errors.length} Falha${errors.length > 1 ? 's' : ''} na Geração de Notas`,
                html: `<ul style="list-style: none; padding: 0; max-height: 400px; overflow-y: auto;">${errorList}</ul>`,
                width: '600px',
                confirmButtonText: 'OK',
              })
            }
          }
        } else if (status === 500) {
          this.$toast.error((data && data.message) || 'Erro interno ao processar a solicitação')
        } else {
          this.$toast.error('Erro ao consultar notas')
        }
      } finally {
        this.$set(item, 'loading_notes', false)
      }
    },
    joinGuest(checkout) {
      if (checkout.accommodation) {
        const guests = checkout.accommodation.guest
        const guestsName = []
        guests.forEach(guest => {
          guestsName.push(guest.name)
        })

        return guestsName.join(', ')
      }
    },
    getTomadores(checkout) {
      const primary = Array.isArray(checkout.tomadores)
        ? checkout.tomadores.filter(name => name && name.trim() !== '')
        : []

      if (primary.length) {
        return [...new Set(primary)]
      }

      const fallback = []
      if (checkout.type_of_person_fiscal === 'PJ' && checkout.company_fiscal) {
        fallback.push(
          checkout.company_fiscal.fantasy_name
          || checkout.company_fiscal.razao_social
          || '',
        )
      } else if (checkout.type_of_person_fiscal === 'PF' && checkout.guest_fiscal) {
        fallback.push(checkout.guest_fiscal.name || '')
      }

      return fallback.filter(name => name && name.trim() !== '')
    },
    getTomador(checkout) {
      const list = this.getTomadores(checkout)

      return list.length ? list[0] : '-'
    },
    joinTomadores(checkout) {
      return this.getTomadores(checkout).join(', ')
    },
    showNote(item) {
      const accommodation_id = item.accommodation.id
      this.getAccommodationObservations(accommodation_id).then(response => {
        this.accommodation_observations = response.data
      })
      this.dialogNote = true
    },

    // calcPayment(item) {
    //   const sum_payment = item.payment.reduce((acc, payment) => {
    //     return (
    //       acc +
    //       (parseFloat(payment.subtotal) +
    //         parseFloat(payment.tax) +
    //         parseFloat(payment.additional) -
    //         parseFloat(payment.discount))
    //     )
    //   }, 0)

    //   return this.formatMoney(sum_payment)
    // },
    clearFilter() {
      this.filter = {}
      this.search = ''
      this.options.page = 1
      this.initialize()
      this.dialogFilter = false
    },
    confirmFilter() {
      this.options.page = 1
      this.initialize()
      this.dialogFilter = false
    },
    confirmSearch() {
      this.options.page = 1
      this.initialize()
    },
    formatMoney(value) {
      value = parseFloat(value)
      if (value != null) {
        return value.toLocaleString('pt-br', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      }
    },
    formatDateTime(date) {
      if (date) {
        const result = new Date(date)

        return (
          `${result.toLocaleDateString('pt-BR', {
            timeZone: 'UTC',
          })
          } ${
            result.toLocaleTimeString('pt-BR')}`
        )
      }
    },
    getuser(checkout) {
      if (checkout.user) {
        return checkout.user.name
      }

      return checkout
    },
    exportPdf(checkout) {
      checkout.loading_print = true
      this.printCheckoutPdf(checkout)
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', 'voucher.pdf')
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch(response => {
          console.log(response)
        })
        .finally(() => {
          this.checkouts.forEach(item => {
            item.loading_print = false
          })

          // armegagem para força a reação do vue
          const backup = this.checkouts
          this.checkouts = []
          this.checkouts = backup
        })
    },
    exportPdfRpd(checkout) {
      checkout.loading_print = true
      this.exportPdfRps(checkout)
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', 'rps.pdf')
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch(response => {
          console.log(response)
        })
        .finally(() => {
          this.checkouts.forEach(item => {
            item.loading_print = false
          })

          // armegagem para força a reação do vue
          const backup = this.checkouts
          this.checkouts = []
          this.checkouts = backup
        })
    },
    cancelCheckout(checkout) {
      this.performRevertCheckout(checkout)
    },

    performRevertCheckout(checkout, token = null) {
      let request
      if (token) {
        // Com autorização temporária (após 403)
        request = this.$http.post(`manager_accommodation/revert_checkout/${checkout.id}`, {}, {
          headers: { Authorization: `Bearer ${token}` },
        })
      } else {
        // Primeira tentativa (com token do usuário atual)
        request = this.revertCheckout(checkout.id)
      }

      return request
        .then(() => {
          this.$toast.success('Checkout reaberto com sucesso')
          this.initialize()
        })
        .catch(error => {
          // Detecta 403 e solicita autorização
          if (!token && error?.response?.status === 403) {
            this.queueAuthorization('revert_checkout', checkout)

            return Promise.resolve()
          }

          // Outros erros
          const apiMessage = error.response?.data?.message || error.response?.data || 'Erro desconhecido'
          this.$toast.error(`Erro ao reabrir checkout: ${apiMessage}`)

          return Promise.reject(error)
        })
    },
    sendSingleCheckoutToGestao(checkout) {
      this.performSendCheckout(checkout)
    },

    performSendCheckout(checkout, token = null) {
      this.$set(checkout, 'loading_send', true)

      let request
      if (token) {
        // Com autorização temporária (após 403)
        request = this.$http.post(`manager_accommodation/send_single_checkout/${checkout.id}`, {}, {
          headers: { Authorization: `Bearer ${token}` },
        })
      } else {
        // Primeira tentativa (com token do usuário atual)
        request = this.sendSingleCheckout(checkout.id)
      }

      return request
        .then(() => {
          this.$toast.success('Checkout enviado para gestão')
          this.initialize()
        })
        .catch(error => {
          // Detecta 403 e solicita autorização
          if (!token && error?.response?.status === 403) {
            this.queueAuthorization('send_checkout', checkout)

            return Promise.resolve()
          }

          // Outros erros
          const apiMessage = error.response?.data?.message || 'Erro desconhecido'
          const detailedErrors = Array.isArray(error.response?.data?.errors)
            ? error.response.data.errors
              .map(err => {
                const type = err.type ? err.type.toUpperCase() : 'ERRO'
                const proposal = err.proposal_id ? `#${err.proposal_id}` : ''
                const reason = err.message || err.reason || ''

                return `${type} ${proposal} - ${reason}`
              })
              .join(' | ')
            : ''

          const toastMessage = detailedErrors
            ? `${apiMessage}: ${detailedErrors}`
            : apiMessage

          this.$toast.error(`Erro ao enviar checkout: ${toastMessage}`)

          return Promise.reject(error)
        })
        .finally(() => {
          this.$set(checkout, 'loading_send', false)
        })
    },
    sendExportPdf() {
      const payload = { ...this.filter, search: this.search }
      this.exportPdfReport(payload)
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', 'export.pdf')
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .finally()
    },

    queueAuthorization(type, payload = null) {
      this.pendingAuthorization = { type, payload }
      this.dialogAuthorization = true
    },

    requestAuthorization() {
      if (!this.validEmail() || !this.validPassword()) return

      const pending = this.pendingAuthorization

      if (!pending) {
        this.$toast.error('Nenhuma ação pendente para autorização')

        return
      }

      const credentials = {
        email: this.admLogin.email,
        password: this.admLogin.password,
      }

      // Não valida role - qualquer usuário com a permissão específica pode autorizar
      const validate = loginData => true

      // Executa a ação conforme o tipo
      const request = token => {
        switch (pending.type) {
          case 'send_checkout':
            return this.performSendCheckout(pending.payload, token)
          case 'revert_checkout':
            return this.performRevertCheckout(pending.payload, token)
          default:
            return Promise.resolve()
        }
      }

      this.authorizationProcessing = true

      this.runAuthorization({ credentials, validate, request })
        .then(() => {
          this.dialogAuthorization = false
          this.pendingAuthorization = null
          this.$toast.success('Usuário autorizado')
        })
        .catch(error => {
          const message = error?.response?.data?.message
                         || error?.message
                         || 'Usuário não autorizado'
          this.$toast.error(message)
        })
        .finally(() => {
          this.authorizationProcessing = false
          this.admLogin.email = ''
          this.admLogin.password = ''
          this.message_error_email = ''
          this.message_error_password = ''
        })
    },

    validEmail() {
      if (this.admLogin.email === '') {
        this.message_error_email = 'Obrigatório'

        return false
      }
      this.message_error_email = ''

      return true
    },

    validPassword() {
      if (this.admLogin.password === '') {
        this.message_error_password = 'Obrigatório'

        return false
      }
      this.message_error_password = ''

      return true
    },

    cancelAuthorization() {
      this.dialogAuthorization = false
      this.pendingAuthorization = null
      this.admLogin.email = ''
      this.admLogin.password = ''
      this.message_error_email = ''
      this.message_error_password = ''
      this.authorizationProcessing = false
    },
  },
}
</script>
